export const FindRoastLightFlow = [
  [
    {
      type: "comment",
      hint: [
        "哈囉，我是大咖，接觸過淺焙咖啡嗎？這是表現精品咖啡很常見的烘焙方式喔！"
      ]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["讓我來跟你簡單說明一下吧!"],
      choices: [
        { label: "好啊!", value: 1 },
        { label: "什麼是淺焙啊？", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message:
            "淺焙有著淡咖啡色、棕褐色的外觀且烘焙後的豆子油脂較少，是所有焙度中酸質最明顯且最鮮明的咖啡。\r\n而不同地區生長的咖啡以淺焙呈現時，最能展現該支咖啡的品質，絕大多數品嘗到的都是咖啡原始的風味，而這也是杯測常用淺焙豆測試的原因。"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["試試看淺焙的咖啡豆嗎？"],
      choices: [
        { label: "滿有趣的喔，想品嚐！", value: 1 },
        { label: "好的，我想試試看！", value: 2 }
      ],
      afterAnswer: async resp => {
        return { message: "好的，推薦給你淺焙的咖啡豆！" };
      },
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/products/淺焙", label: "淺焙" }]
    }
  ]
];

export const FindRoastMediumFlow = [
  [
    {
      type: "comment",
      hint: ["哈囉，我是大咖，一般中焙的咖啡豆味道比較均勻且容易入口~"]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["想多了解看看嗎？"],
      choices: [
        { label: "好喔，想聽聽!", value: 1 },
        { label: "什麼是中焙啊？", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message:
            "中焙咖啡較淺焙有著更深褐色的外觀，咖啡的油脂也可能在表面就看得到。\r\n這種焙度的咖啡讓烘豆師引出咖啡風味及香氣外，還能平衡酸質與醇厚度，一樣能從中焙咖啡品嘗到咖啡原始的風味，但咖啡鮮明的酸質會因為烘焙過程而被飽滿的醇厚度取代。"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["試試看中焙的咖啡豆嗎？"],
      choices: [
        { label: "聽起來很不錯！", value: 1 },
        { label: "好的，我想試試看！", value: 2 }
      ],
      afterAnswer: async resp => {
        return { message: "好的，推薦給你中焙的咖啡豆！" };
      },
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/products/中焙", label: "中焙" }]
    }
  ]
];

export const FindRoastHeavyFlow = [
  [
    {
      type: "comment",
      hint: [
        "哈囉，我是大咖，接觸過深焙咖啡嗎？這種烘焙方式在一般咖啡店很常見喔！"
      ]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["想多了解看看嗎？"],
      choices: [
        { label: "想聽聽看！", value: 1 },
        { label: "什麼是深焙啊？", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message:
            "當品嘗深焙咖啡時幾乎只能喝到烘焙時產生的風味，咖啡淺焙時的鮮明酸質會被深焙的醇厚度所取代。\r\n咖啡在深焙後，產地原始風味幾乎會消失，你很難在深焙咖啡中喝到咖啡的地域性差異，但味道卻能夠在這個焙度上展現獨到個人風格。"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["試試看深焙的咖啡豆嗎？"],
      choices: [
        { label: "買來加個牛奶！", value: 1 },
        { label: "好的，推薦給你深焙的咖啡豆！", value: 2 }
      ],
      afterAnswer: async resp => {
        return { message: "好的，推薦給你深焙的咖啡豆！" };
      },
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/products/深焙", label: "深焙" }]
    }
  ]
];
